<template>
	<div>
		<information-card
			sub-title="Descripción"
			title="MODELO DIRECTRIZ"
		>
			<div slot="content">
				<div v-html="description"></div>
			</div>
		</information-card>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { find, pathOr, pipe, prop, propEq } from 'ramda';
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'guideline-model-instructions',
	components: { InformationCard },
	computed: {
		...mapState('jobEvaluation', {
			description: pipe(
				pathOr([], ['mainData', 'config', 'stages', 0, 'details']),
				find(propEq('goTo', 'job-supply-guideline-model')),
				prop('instructions'),
			),
		}),
	},
};
</script>

<style lang='scss' scoped>
.content-factors {
	width: 100% !important;
	position: relative !important;
	top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-model-instructions.vue